export default {
  company: {
    education: {
      default_education_course: 'משפטים',
      default_education_degree: 'תואר ראשון'
    }
  },
  applicantOffers: {
    defaultSorters: '-sent_at'
  }
}
